import { createContext, useContext } from 'react';

import type { SeriesActionsTemplate } from '../../types/series-actions-template.js';

type Actions<T> = (series: T, ...rest: unknown[]) => SeriesActionsTemplate;
interface ChartSeriesActionContextProps {
  chartSeriesActions?: Actions<unknown>;
}

export const ChartSeriesActionContext =
  createContext<ChartSeriesActionContextProps>({});

export const useSeriesActions = () => useContext(ChartSeriesActionContext);

ChartSeriesActionContext['displayName'] = 'ChartSeriesActionContext';
